import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ch-report-listing',
  templateUrl: './report-listing.component.html',
  styleUrls: ['./report-listing.component.css'],
})
export class ReportListingComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/reports/report-listing/report-listing.component.ts